'use client';

import {useContext, useEffect} from 'react';
import {useActiveScreenId} from '@features/activeScreenIdContext/useActiveScreenId';
import {FlowContext} from '@features/contexts/FlowContext';
import {getLastSelectedScreenStorageKey} from './keys';

/**
 * Get the stored last selected screen ID from localStorage.
 * Returns null if no screen ID is stored.
 */
export function getStoredLastSelectedScreenId(flowId: string): string | null {
  return localStorage.getItem(getLastSelectedScreenStorageKey(flowId));
}

/**
 * Save the last selected screen ID to localStorage.
 */
function saveLastSelectedScreenId(flowId: string, screenId: string): void {
  localStorage.setItem(getLastSelectedScreenStorageKey(flowId), screenId);
}

/**
 * Isolated component for syncing activeScreenId to localStorage.
 * This component re-renders when activeScreenId changes,
 * but doesn't cause the parent Canvas component to re-render.
 */
export function ActiveScreenLocalStorageSync() {
  const chatId = useActiveScreenId();
  const {flow} = useContext(FlowContext);

  useEffect(() => {
    if (!chatId) return;
    saveLastSelectedScreenId(flow.id, chatId);
  }, [chatId, flow.id]);

  return null;
}
